import type { SVGProps } from 'react'

export function Quote(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="32"
      viewBox="0 0 40 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 31.6562V23.1562C0 20.5312 0.458333 17.8229 1.375 15.0312C2.33333 12.1979 3.64583 9.51042 5.3125 6.96875C7.02083 4.38542 8.95833 2.17708 11.125 0.34375L18.625 5.03125C16.9583 7.65625 15.5833 10.4271 14.5 13.3438C13.4583 16.2188 12.9375 19.4688 12.9375 23.0938V31.6562H0ZM20.5 31.6562V23.1562C20.5 20.5312 20.9583 17.8229 21.875 15.0312C22.8333 12.1979 24.1458 9.51042 25.8125 6.96875C27.5208 4.38542 29.4583 2.17708 31.625 0.34375L39.125 5.03125C37.4583 7.65625 36.0833 10.4271 35 13.3438C33.9583 16.2188 33.4375 19.4688 33.4375 23.0938V31.6562H20.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
